export default (val)=>{
  if(typeof val === 'boolean'){
    return val
  }
  if(typeof val === 'string'){
    if(val === 'true'){
      return true
    }
    return false
  }
  if(typeof val ==='number'){
    if(val === 1){
      return true
    }
    return false
  }
}
